import { SIGNUP_URL } from '../data/content';
import { useReveal } from '../hooks/useReveal';
import './Hero.scss';

/**
 * Clean centered hero. Just identity:
 *   - Eyebrow pill ("Now in public beta")
 *   - Lowercase display headline
 *   - Sub copy
 *   - Two CTAs
 *   - A scroll-cue affordance at the bottom that hints "there's more".
 *
 * No demo windows here — the alternating tout section below shows
 * real samples of PageLoop in different app contexts.
 */
export function Hero() {
	const ref = useReveal<HTMLDivElement>();

	return (
		<section class="m-hero" id="top">
			<div class="m-hero__orbit" aria-hidden="true">
				<span class="m-hero__orbit-ring" />
				<span class="m-hero__orbit-ring m-hero__orbit-ring--inner" />
				<span class="m-hero__orbit-sat" />
				<span class="m-hero__orbit-sat m-hero__orbit-sat--inner" />
			</div>

			<div class="m-hero__copy" ref={ref}>
				<span class="m-hero__pill">
					<span class="m-hero__pill-dot" />
					Now in public beta
				</span>

				<h1 class="m-hero__headline">
					<span>real-time comments</span>
					<span class="m-hero__headline-row">
						<span class="m-hero__accent">on</span>{' '}
						<em class="m-hero__italic">any page.</em>
					</span>
				</h1>

				<p class="m-hero__sub">
					Inject a script, or use a framework provider — works with static
					sites and apps, local or remote. Threaded comments anchored to any
					element, plus direct agent-ready task links (full context included)
					that turn feedback into work an AI agent can finish for you.
				</p>

				<div class="m-hero__cta-row">
					<a class="m-btn m-btn--primary" href={SIGNUP_URL}>
						Start hosting for free
					</a>
					<a class="m-btn m-btn--ghost" href="#samples">
						See it in action
					</a>
				</div>

				<p class="m-hero__try">
					<span class="m-hero__try-dot" aria-hidden="true" />
					<span class="m-hero__try-text">
						This page is a live demo. <strong>Highlight any text</strong>, or tap
						the <strong>PageLoop button</strong> in the bottom-right corner, to
						leave a comment right now.
					</span>
				</p>
			</div>

			<a class="m-hero__scroll" href="#samples" aria-label="Scroll to samples">
				<span class="m-hero__scroll-label">scroll</span>
				<span class="m-hero__scroll-arrow" aria-hidden="true" />
			</a>
		</section>
	);
}
